//Yotpo account page 
var SHOPIFY_BASE_URL = window.location.href.includes('vuse-nz-staging') ? 'https://vuse-nz-staging.myshopify.com/' : 'https://vuse.co.nz/';
var isStaging = SHOPIFY_BASE_URL.includes('vuse-nz-staging') ? true : false;
var ZYBER_URL = isStaging ? 'https://vusestaging.zyberclients.co.nz' : 'https://vusehsm.zyberclients.co.nz';

var stagingToken = '5C*}n>nHt_}907I|cn[X7^H^Bm67iy0h:S3Ju+8aBB?*LSiSefp+?+[l@Xld:Pd'
var headersOption = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};
// Staging Store requires token 
if (isStaging) {
  headersOption['X-VUSE-API-AUTH'] = stagingToken;
}

function purchaseYotpoReward(couponId) {
  account_pageLoading('show');
  var onSuccess = function(redemption) {
    account_pageLoading('hide');
    console.log('redemption.couponCode',redemption.couponCode)
    // fillAndSubmitCouponCodeForm(redemption.couponCode);
    $.fancybox.open('<div class="yotpo-coupon-success"><h3>Coupon created</h2><p>Your code is <span class="green-text">' + redemption.couponCode + '</span></p></div>')
    $('.yotpo-coupon-success').fancybox({
      afterClose  : function() {
        location.reload(); 
      }
    });
  };
  var onError = function(err) {
    account_pageLoading('hide');
    $("#error").show();
  };

  swellAPI.makeRedemption(
    { redemptionOptionId: couponId },
    onSuccess,
    onError
  );
}

function buildYotpoRewards(a, callback){
    console.log('##buildYotpoRewards - ', a)
    let result = swellAPI.getActiveRedemptionOptions()
    var rewardHtml = '',
        variableHtml = '';
    for ( var i=0; i < result.length; i++ ){

      var item = result[i],
          points = item.costInPoints,
          
          // pointsName = item.exchange_description.split(item.points_price + ' ')[1],
          pointsName = 'Vuse+ Points',
          rewardId = item.id,
          pointsRequired = points - a.customerPoints,
          rewardName = item.name,
          rewardIconText = item.name.split(' ')[0],
          j = i+1,
          // pointsRequiredHtml = theme.Currency.formatMoney(points, theme.moneyFormat).replace('.00', ''),
          pointsRequiredHtml = formatMoneyNoDecimal(points);

          console.log('points', points, rewardName, '... ....pointsRequired?', pointsRequired)

          if ( item.discountType === 'variable' ){
            const title = a.variableContainer.find('input').val();   
            variableHtml = `<div class="customer--rewards-block customer--variable" data-points="${points}" ><div class="customer--rewards-icon text-center h1"><span>$</span></div><div class="customer--rewards-info description"><h4 class="h4">${title}</h4><h6 class="h6"><span class="points-required">${item.description}</span></h6><span class="green-text">You can choose how many points you'd like to use at checkout.</span></div></div>`;
            break;
          }

      if ( rewardIconText.indexOf('$') > -1 ){
        continue;
      }
      rewardHtml += `<div class="grid__item one-half customer--rewards-block customer--rewards${j}" data-points="${points}">
                      <div class="customer--rewards-icon text-center h1 ${pointsRequired <= 0 ?? 'active'}">
                        <span>${rewardIconText}</span>
                      </div>
                      <div class="customer--rewards-info description">
                        <h4 class="h4">${rewardName}</h4>
                    `
      if ( points > 0 ){
        rewardHtml += `<h6 class="h6"><span class="points-required">${pointsRequiredHtml}</span> ${pointsName}</h6>`
      }
      
      rewardHtml += `<span class="customer--points-info"><span class="content">`;

      if (pointsRequired > 0) {   
        /*rewardHtml += `You need <span class="points-remainder">${pointsRequired}</span> more ${pointsName}` */
        console.log('nopoints')
      } else if (points > 0) {
        rewardHtml += `<a class="swell-redemption-link btn customer--reward-btn" data-redemption-option-id="${rewardId}"  data-reward-points="${points}"  onClick="purchaseYotpoReward(${rewardId})">BUY VOUCHER</a>`;
      }
      rewardHtml += `</span></span></div></div>`
    }
      a.rewardsContainer.empty();
      a.rewardsContainer.append(rewardHtml);
      a.variableContainer.html(variableHtml);
      callback();
}

function formatUsedDate(formattedArray) {
  return formattedArray[0] + '-' + formattedArray[1].slice(0,3) +  '-' + formattedArray[2].slice(2);
}

function checkExistingYotpoCodes(callback){
  let result = swellAPI.getAllCustomerRedemptions()
    const history_wrapper = $('.history_wrapper');
    let historyHtml = '';
    // console.log('history', result)
    if ( result.length === 0 ){
      historyHtml = 'You have not purchased any vouchers.';
      history_wrapper.html(historyHtml);
      return;
    }

    result.forEach(item => {
      $.ajax({
        type: "GET",
        url: ZYBER_URL + '/api/disc/codeStatus?codes[]=' + item.reward_text
        }).done(function(response) {
          let responseData = response[1].data;
          // console.log(response[1].data,"newresponse")
          if( responseData != null) {
            let name = '';
            if ( item.redemption_option.discount_type == 'variable' ) {
                name = formatMoneyWithDecimal(item.amount) + ' ' + 'redeemed';
            } else {
                name = item.redemption_option.name
            }
            let used = false;
              if(responseData.discount_code.usage_count > 0 ) {
                used = true;
              }
              let expired = false;
              let now = new Date()
              if(new Date(responseData.price_rule.ends_at) < now) {
              expired = true;
              }
              historyHtml += '<div class="history">' +
                            '<div class="col-1">' +
                              '<p class="h6 margin-bottom-5">' + name +
                              '</p>' +
                              '<p class="paragraph">' +
                                'Purchase date: ' +
                                dataDate(item.created_at) +
                              '</p>' +
                            '</div>' +
                            '<div class="col-2">';
              if (used){
              historyHtml += '<span class="used-btn">REDEEMED ' + formatUsedDate(dataDate(responseData.discount_code.updated_at).split(' ')) + '</span>';
              } else if(expired) {
              historyHtml += '<span class="used-btn expired">EXPIRED ' + formatUsedDate(dataDate(responseData.price_rule.ends_at).split(' ')) + '</span>';
              } else {
              historyHtml += '<div id="reward-code--' + 
                        item.id +
                        '" class="copy-container"  data-content="' + 
                        item.reward_text +
                        '"><span class="url">' + 
                        item.reward_text + 
                        '</span><svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 12.875H4.15625C3.30859 12.875 2.625 12.1914 2.625 11.3438V3.25H0.65625C0.273438 3.25 0 3.55078 0 3.90625V13.9688C0 14.3516 0.273438 14.625 0.65625 14.625H8.09375C8.44922 14.625 8.75 14.3516 8.75 13.9688V12.875ZM8.75 3.46875V0.625H4.15625C3.77344 0.625 3.5 0.925781 3.5 1.28125V11.3438C3.5 11.7266 3.77344 12 4.15625 12H11.5938C11.9492 12 12.25 11.7266 12.25 11.3438V4.125H9.40625C9.02344 4.125 8.75 3.85156 8.75 3.46875ZM12.0312 2.62109L10.2539 0.84375C10.1445 0.734375 9.92578 0.625 9.78906 0.625H9.625V3.25H12.25V3.08594C12.25 2.94922 12.1406 2.73047 12.0312 2.62109Z" fill="#D6042C"/></svg><div class="copied">Copied!</div></div>';
              }
              historyHtml += '</div>' +
                          '</div>';
                          history_wrapper.html(historyHtml);
                          if ( callback ){
                            callback();
                          }
          }
        }).fail(function(jqXHR, textStatus) {
          console.log('Connection failed. Please try again later.', jqXHR,textStatus);
        });      
      

    });
    
}


function vusePlusAdditionalYotpoFucntions(a){
var progress_barHtml = '<div class="progress-bar-wrapper"><div class="progress-wrap progress data_progress_percent" data-progress-percent="25"><div class="progress-bar progress"></div></div><p class="progress-bar-text"></p><span class="dollar"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14" fill="#4DD8C8" stroke="#4DD8C8" stroke-width="2"/><path d="M18.84 13.504V11.656C18.434 10.942 17.594 10.27 16.096 10.046V9.36H14.066V10.046C12.568 10.256 11.7 10.97 11.308 11.656V14.596C11.7 15.282 12.596 15.842 14.71 16.234C15.452 16.402 15.662 16.458 15.76 16.626V17.508C15.648 17.662 15.396 17.788 15.06 17.788C14.738 17.788 14.444 17.662 14.374 17.508V16.668H11.308V18.544C11.7 19.23 12.568 19.944 14.066 20.154V20.994H16.096V20.154C17.594 19.93 18.434 19.23 18.84 18.544V15.52C18.448 14.848 17.538 14.316 15.466 13.882C14.696 13.7 14.472 13.63 14.374 13.476V12.706C14.472 12.552 14.738 12.412 15.06 12.412C15.396 12.412 15.69 12.552 15.76 12.706V13.504H18.84Z" fill="#1D1D1B"/></svg></span></div>';
//var vuse_point = $("#loyalty_points-amount").attr("data-loyalty-points");
var vuse_point = a.customerPoints;
var requiredPoint = 0;
$(".customer--rewards-block").each(function() {
  var point = $(this).attr("data-points");
  if (point == "null") {
    return;
  }

  requiredPoint = parseInt(point);
  if (vuse_point >= requiredPoint ) {
    return;
  }
  $(this).append(progress_barHtml);

  var neededPoints = requiredPoint - vuse_point;
  var neededPercent = ( vuse_point * 100) / requiredPoint;

  $(this)
    .find(".data_progress_percent")
    .attr("data-progress-percent", neededPercent);
  $(this)
    .find(".progress-bar-text")
    .text("You need " + neededPoints + " more Vuse+ points");
    moveProgressBar();
});
}


function generateYotpoTransaction(response){
     const data = response.history_items,
           $container = $('[data-transaction-container]'),
           $expiry = $('[data-expiry-date]'),
           expiryDate = '11.59PM 16 JUNE 2025';
           //expiryDate = response.next_points_expire_on != null ? dataDate(response.next_points_expire_on) : '17 June 2025';
     if ( !data || data.length === 0 ) $('.expire-text').addClass('hide');
     let transactionHtml = '';

     console.log('generateYotpoTransaction --->', response, data, response.points_expire_at, response.next_points_expire_on)

     data.forEach(transaction => {
      transactionHtml += '<div class="transaction">' +
                            '<div class="col-1">' +
                              '<p class="h6 margin-bottom-5">' +
                              transaction.action +
                              '</p>' +
                              '<p class="paragraph color-black">';

      if ( transaction.points < 0 ){
        transactionHtml += transaction.points;
      } else {
        transactionHtml += '+' + transaction.points;
      }
            transactionHtml += ' Vuse+ Points</p>' +
                            '</div>' +
                            '<div class="col-2">' +
                              '<p class="small color-black">' +
                                dataDate(transaction.created_at) +
                              '</p>' +
                            '</div>' +
                          '</div>';
     });
     $container.html(transactionHtml);
     $expiry.text(expiryDate);
  }

document.addEventListener('DOMContentLoaded', function() {
    $(document).on("swell:setup", function() {
    // do something using logged in customer (campaigns and redemption options available too)
       var customerDetails = swellAPI.getCustomerDetails();
       var data = {
        "referralUrl" : customerDetails.referralLink,
        "customerPoints" : customerDetails.pointsBalance,
        "referralContainer" : $('#referral-code'),
        "pointsContainer" : $('[data-loyalty-points]'),
        "rewardsContainer" : $('.customer-rewards-section'),
        "variableContainer": $('.account-info--variable-rewards'),
        "rewardBtn" : '.customer--reward-btn',
        "customerEmail":customerDetails.email
       };
       $('#referral-code-yotpo').attr('data-content',data.referralUrl)
       $('#referral-code-yotpo .url').text(data.referralUrl)
       $('#referral-code-yotpo .url').text(data.referralUrl)
       $('.swell-point-balance').text(formatMoneyNoDecimal(data.customerPoints))
     
       //get Zyber API for transaction
       // console.log('testtttttt headersOption ====> ', headersOption)
       let params = {
        "email": data.customerEmail
      }
       $.ajax({
        type: "POST",
        url: ZYBER_URL + '/api/yotpo/getTransactions',
        data: JSON.stringify(params),
        headers: headersOption,
        dataType: 'json'
       }).done(function(response) {
        generateYotpoTransaction(response);
       }).fail(function(jqXHR, textStatus) {
        alert('Connection failed. Please try again later.');
       });      
       copyToClipboard('.copy-container')
       buildYotpoRewards(data, function() {
        checkExistingYotpoCodes();
        vusePlusAdditionalYotpoFucntions(data);  
       });
    });
});